// Static data for The 30s FF
export const TEAM_NAME = "The 30s FF";
export const TEAM_TAGLINE = "FUN FOOTBALL. SERIOUS PASSION.";

export const HERO_STATS = [
  { value: "25+", label: "ANGGOTA" },
  { value: "5 TH", label: "BERSAMA" },
  { value: "40+", label: "LAGA" },
  { value: "1", label: "KELUARGA" },
];

export const TICKER_ITEMS = [
  "WELCOME TO THE 30s FF OFFICIAL SITE",
  "MATCHDAY SETIAP SABTU/MINGGU",
  "FUN FOOTBALL · SERIOUS PASSION",
  "BERGABUNG DENGAN KOMUNITAS KAMI",
  "NO SCORE — JUST PURE FUN",
];

export const SPONSORS = [
  { name: "NIKE", icon: "SiNike" },
  { name: "ADIDAS", icon: "SiAdidas" },
  { name: "PUMA", icon: "SiPuma" },
  { name: "NEW BALANCE", icon: "SiNewbalance" },
  { name: "RED BULL", icon: "SiRedbull" },
  { name: "GATORADE", icon: "SiGatorade" },
  { name: "UMBRO", icon: "SiUmbro" },
  { name: "MIZUNO", icon: "SiMizuno" },
];

export const NEXT_MATCH = {
  date: "2026-07-04T15:00:00+07:00",
  dateLabel: "SABTU, 4 JULI 2026 — 15:00 WIB",
  format: "TROFEO",
  competition: "LAGA TROFEO",
  venue: "Stadion Mandala Krida",
  // Format trofeo: lebih dari dua tim bermain dalam satu turnamen singkat.
  teams: [
    {
      name: "The 30s FF",
      short: "30FF",
      role: "TUAN RUMAH",
      logo: "/30sff-logo.png",
    },
    {
      name: "Laonstar",
      short: "LNS",
      role: "PESERTA",
      logo: "/laonstar-logo.png",
    },
    {
      name: "JC Sport Sidayu",
      short: "JCS",
      role: "PESERTA",
      logo: "/jc-sidayu-logo.png",
    },
  ],
};

export const UPCOMING_MATCHES = [
  {
    id: 1,
    date: "27 JUN",
    weekday: "SABTU",
    type: "TROFEO",
    competition: "LAGA TROFEO",
    teams: ["The 30s FF", "Volar", "Laonstar"],
    time: "15:00 WIB",
    venue: "UII Training Ground",
    detailSlug: "trofeo-uii-27-juni",
  },
  {
    id: 2,
    date: "04 JUL",
    weekday: "SABTU",
    type: "TROFEO",
    competition: "LAGA TROFEO",
    teams: ["The 30s FF", "Laonstar", "JC Sport Sidayu"],
    time: "15:00 WIB",
    venue: "Stadion Mandala Krida",
    detailSlug: "trofeo-mandala-krida-4-juli",
  },
  {
    id: 3,
    date: "11 JUL",
    weekday: "SABTU",
    type: "FRIENDLY",
    competition: "FRIENDLY MATCH",
    teams: ["The 30s FF", "John de Brito"],
    time: "15:00 WIB",
    venue: "Lapangan Karang",
    detailSlug: "friendly-john-de-brito-11-juli",
  },
  {
    id: 5,
    date: "25 JUL",
    weekday: "SABTU",
    type: "INTERNAL",
    competition: "INTERNAL GAME",
    teams: ["The 30s FF"],
    time: "15:00 WIB",
    venue: "Lapangan Sidomoyo",
    detailSlug: "internal-game-25-juli",
  },
];

// Detail laga (dibuka saat panah jadwal diklik).
export const MATCH_DETAILS = {
  "trofeo-uii-27-juni": {
    competition: "LAGA TROFEO",
    dateLabel: "SABTU, 27 JUNI 2026",
    time: "15:00 WIB",
    venue: "UII Training Ground",
    teams: ["The 30s FF", "Volar", "Laonstar"],
    // Skuad yang dipanggil untuk laga ini, dikelompokkan per posisi.
    squad: [
      { role: "GK", label: "PENJAGA GAWANG", players: ["Zen", "Kim Wijang"] },
      { role: "CB", label: "BEK TENGAH", players: ["Rhoma P.A", "Ceko", "Wargusito", "Dhana"] },
      { role: "LB/RB", label: "BEK SAYAP", players: ["Alvian", "Bob", "Denis", "Ruud"] },
      { role: "CMF", label: "GELANDANG TENGAH", players: ["Jojo", "Tiko", "Noby", "Septian", "Rezky", "Mimo"] },
      { role: "RMF/LMF", label: "GELANDANG SAYAP", players: ["Hernadi", "Amanu", "Adhitya", "Aldy"] },
      { role: "CF", label: "PENYERANG", players: ["Fadli", "Helmyma", "Babay"] },
    ],
    // Starting lineup (dirilis H-1). Dari belakang (GK) ke depan (ATT).
    lineup: [
      {
        name: "TIM A",
        formation: "4-3-3",
        rows: [
          { line: "GK", players: ["Kim Wijang"] },
          { line: "DEF", players: ["Alvian", "Rhoma P.A", "Wargusito", "Bob"] },
          { line: "MID", players: ["Tiko", "Septian", "Mimo"] },
          { line: "ATT", players: ["Hernadi", "Babay", "Aldy"] },
        ],
      },
      {
        name: "TIM B",
        formation: "4-3-3",
        rows: [
          { line: "GK", players: ["Zen"] },
          { line: "DEF", players: ["Denis", "Ceko", "Dhana", "Ruud"] },
          { line: "MID", players: ["Noby", "Rezky", "Jojo"] },
          { line: "ATT", players: ["Amanu", "Fadli", "Adhitya"] },
        ],
      },
    ],
  },
  "trofeo-mandala-krida-4-juli": {
    competition: "LAGA TROFEO",
    dateLabel: "SABTU, 4 JULI 2026",
    time: "15:00 WIB",
    venue: "Stadion Mandala Krida",
    teams: ["The 30s FF", "Laonstar", "JC Sport Sidayu"],
    squad: [
      { role: "GK", label: "PENJAGA GAWANG", players: ["Hernadi", "Kim Wijang"] },
      {
        role: "DEF",
        label: "PEMAIN BELAKANG",
        players: ["Irvan Kornelis", "Wargu", "Riza", "Alvian", "Mimo", "Rhoma P.A", "Agus", "Simbot"],
      },
      {
        role: "MID",
        label: "GELANDANG",
        players: ["Turmudi", "Septian", "Denis", "Babay", "Nabil", "Emzo"],
      },
      {
        role: "ATT",
        label: "PENYERANG",
        players: ["Amanu", "Helmyma", "Fadli", "Arba", "Fritzie", "Faisal"],
      },
    ],
    lineup: [
      {
        name: "TIM MERAH (A)",
        formation: "4-3-3",
        rows: [
          { line: "GK", players: ["Kim Wijang"] },
          { line: "DEF", players: ["Mimo", "Rhoma P.A", "Agus", "Simbot"] },
          { line: "MID", players: ["Babay", "Nabil", "Emzo"] },
          { line: "ATT", players: ["Arba", "Fritzie", "Faisal"] },
        ],
      },
      {
        name: "TIM HITAM (B)",
        formation: "4-3-3",
        rows: [
          { line: "GK", players: ["Hernadi"] },
          { line: "DEF", players: ["Irvan Kornelis", "Wargu", "Riza", "Alvian"] },
          { line: "MID", players: ["Turmudi", "Septian", "Denis"] },
          { line: "ATT", players: ["Amanu", "Helmyma", "Fadli"] },
        ],
      },
    ],
  },
  "friendly-john-de-brito-11-juli": {
    competition: "FRIENDLY MATCH",
    dateLabel: "SABTU, 11 JULI 2026",
    time: "15:00 WIB",
    venue: "Lapangan Karang",
    teams: ["The 30s FF", "John de Brito"],
    lineup: null,
  },
  "internal-game-25-juli": {
    competition: "INTERNAL GAME",
    dateLabel: "SABTU, 25 JULI 2026",
    time: "15:00 WIB",
    venue: "Lapangan Sidomoyo",
    teams: ["The 30s FF"],
    lineup: null,
  },
};

// Kategori posisi + label untuk ditampilkan
export const POSITION_ORDER = ["GK", "DEF", "MID", "ATT"];
export const POSITION_LABELS = {
  GK: "PENJAGA GAWANG",
  DEF: "PEMAIN BELAKANG",
  MID: "GELANDANG",
  ATT: "PENYERANG",
};

// Foto placeholder sementara (akan diganti foto asli pemain)
const _squadImgs = [
  "https://images.unsplash.com/photo-1517466787929-bc90951d0974?w=400",
  "https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=400",
  "https://images.pexels.com/photos/9469669/pexels-photo-9469669.jpeg?w=400",
  "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=400",
  "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400",
];

// Daftar lengkap skuad The 30s FF. num & img menyusul.
export const FULL_SQUAD = [
  { name: "Kim Wijang", position: "GK", img: "/squad/kim-wijang.jpg" },
  { name: "Dhana", position: "DEF", img: "/squad/dhana.jpg" },
  { name: "Rhoma P.A", position: "DEF", img: "/squad/rhoma.jpg" },
  { name: "Ceko", position: "DEF", img: "/squad/ceko.jpg" },
  { name: "Bob", position: "DEF", img: "/squad/bob.jpg" },
  { name: "Nur", position: "DEF", img: "/squad/nur.jpg" },
  { name: "Septian", position: "MID", img: "/squad/septian.jpg" },
  { name: "Tiko", position: "MID", img: "/squad/tiko.jpg" },
  { name: "Mimo", position: "MID", img: "/squad/mimo.jpg" },
  { name: "Gendhis", position: "MID", img: "/squad/gendhis.jpg" },
  { name: "Amanu", position: "ATT", img: "/squad/amanu.jpg" },
  { name: "Helmyma", position: "ATT", img: "/squad/helmi.jpg" },
  { name: "Herna", position: "ATT", img: "/squad/herna.jpg" },
  { name: "Zen", position: "GK", img: "/squad/zen.jpg" },
  { name: "Aries", position: "GK", img: "/squad/aries.jpg" },
  { name: "Ruud", position: "DEF", img: "/squad/ruud.jpg" },
  { name: "Irvin", position: "DEF", img: "/squad/irvin.jpg" },
  { name: "SimBot", position: "DEF", img: "/squad/simbot.jpg" },
  { name: "Wargusito", position: "DEF", img: "/squad/wargusito.jpg" },
  { name: "Alvian", position: "DEF", img: "/squad/alvian.jpg" },
  { name: "Jojo", position: "MID", img: "/squad/jojo.jpg" },
  { name: "Rezky", position: "MID", img: "/squad/rezky.jpg" },
  { name: "Denis", position: "MID", img: "/squad/denis.jpg" },
  { name: "Fadli", position: "ATT", img: "/squad/fadli.jpg" },
  { name: "Aldy", position: "ATT", img: "/squad/aldy.jpg" },
  { name: "Adhitya", position: "ATT", img: "/squad/adhitya.jpg" },
  { name: "Koh Hengky", position: "MID", img: "/squad/koh-hengky.jpg" },
  { name: "Turmudi", position: "ATT", img: "/squad/aza.jpg" },
  { name: "Dedek", position: "ATT", img: "/squad/dedek.jpg" },
  { name: "Cakpep", position: "MID", img: "/squad/cakpep.jpg" },
  { name: "Noby", position: "MID", img: "/squad/nobi.jpg" },
  { name: "Zaki", position: "ATT", img: "/squad/zaki.jpg" },
  { name: "Faisal", position: "ATT", img: "/squad/faisal.jpg" },
  { name: "Wahyu", position: "MID", img: "/squad/wahyu.jpg" },
  { name: "Gabriel", position: "MID", img: "/squad/gabriel.jpg" },
  { name: "Nabil", position: "MID", img: "/squad/nabil.jpg" },
  { name: "Ulfa", position: "MID", img: "/squad/ulfa.jpg" },
  { name: "Kornel", position: "DEF", img: "/squad/kornel.jpg" },
  { name: "Tam Riski", position: "DEF", img: "/squad/tam-riski.jpg" },
  { name: "Rahmad", position: "DEF", img: "/squad/rahmad.jpg" },
  { name: "Babay", position: "ATT", img: "/squad/babay.jpg" },
  { name: "Irvan Kornelis", position: "DEF", img: "/squad/irvan-kornelis.jpg" },
  // Foto dummy sementara (akan diganti foto asli)
  { name: "Agus", position: "DEF", img: "https://images.unsplash.com/photo-1517466787929-bc90951d0974?w=600" },
  { name: "Riza", position: "DEF", img: "https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=600" },
  { name: "Emzo", position: "MID", img: "https://images.pexels.com/photos/36513047/pexels-photo-36513047.jpeg?w=600" },
  { name: "Arba", position: "ATT", img: "https://images.unsplash.com/photo-1626248801379-51a0748a5f96?w=600" },
  { name: "Fritzie", position: "ATT", img: "https://images.unsplash.com/photo-1602674809970-89073c530b0a?w=600" },
].map((p, i) => ({
  ...p,
  id: i + 1,
  positionLabel: POSITION_LABELS[p.position],
  img: p.img || `${_squadImgs[i % _squadImgs.length]}&sat=-100`,
}));

// Preview di beranda: 6 penyerang (cukup 1 baris)
export const SQUAD = FULL_SQUAD.filter((p) => p.position === "ATT").slice(0, 6);

export const PLAYER_OF_MONTH = {
  name: "TIKO",
  rating: 89,
  position: "GELANDANG",
  img: "/squad/tiko.jpg",
  quote: "“Assist itu seni, dan trivela bahasanya.”",
  stats: [
    { label: "ASSIST", value: 6, bar: 90 },
    { label: "GOL", value: 0, bar: 8 },
    { label: "KEY PASS", value: 18, bar: 80 },
    { label: "FORM", value: "ON FIRE", bar: 85 },
  ],
};

export const MATCH_CENTER = {
  lastMatch: {
    home: "The 30s FF",
    away: "Bapak-Bapak FC",
    score: "3 - 1",
    date: "11 JAN 2026",
  },
  stats: [
    { label: "POSSESSION", home: 62, away: 38 },
    { label: "SHOTS ON TARGET", home: 9, away: 4 },
    { label: "PASSES", home: 312, away: 198 },
    { label: "FOULS", home: 7, away: 11 },
  ],
  stadiumImg: "https://images.pexels.com/photos/12201296/pexels-photo-12201296.jpeg",
};

export const GALLERY = [
  { src: "/gallery/gol-pembuka.jpg", tall: true, caption: "GOL PEMBUKA" },
  { src: "/gallery/celebration.jpg", tall: false, caption: "CELEBRATION" },
  { src: "/gallery/tim-solid.jpg", tall: false, caption: "TIM SOLID" },
  { src: "/gallery/aksi-lapangan.jpg", tall: false, caption: "AKSI LAPANGAN" },
  { src: "/gallery/dribble-maut.jpg", tall: true, caption: "DRIBBLE MAUT" },
  { src: "/gallery/matchday.jpg", tall: false, caption: "MATCHDAY" },
];

export const CONTACT = {
  instagram: "@the30s.ff",
  instagramUrl: "https://instagram.com/the30s.ff",
  base: "Stadion Sultan Agung, Bantul",
};

export const ARTICLES = [
  {
    slug: "review-lapangan-karang-kotagede",
    title: "Review Lapangan Karang Kotagede: Rumput Sekelas GBK di Jantung Kota Gede",
    category: "REVIEW LAPANGAN",
    date: "2026-06-12",
    author: "Tim Media The 30s",
    location: "Prenggan, Kotagede, Kota Yogyakarta",
    rating: 4.7,
    cover: "/lapangan-karang.jpg",
    excerpt:
      "Lapangan legendaris di Kota Gede yang sudah direnovasi dengan rumput zoysia matrella sekelas GBK. Main bola sambil kulineran, paket lengkap khas Jogja.",
    content: [
      "Lapangan Karang Kotagede bukan lapangan sembarangan. Berlokasi di Prenggan, Kotagede, lapangan seluas sekitar 6.283 meter persegi ini adalah aset Pemerintah Kota Yogyakarta yang dikelola oleh Dinas Pendidikan, Pemuda, dan Olahraga.",
      "Sejak direnovasi, lapangan ini memakai rumput jenis zoysia matrella, jenis rumput yang sama dengan yang dipakai di stadion-stadion besar. Pijakannya empuk dan rata, bola bergulir mulus, dan permukaannya nyaman buat tim yang suka membangun serangan dari kaki ke kaki. Tidak heran kalau lapangan ini sering disebut punya rumput sekelas GBK.",
      "Yang bikin Lapangan Karang istimewa adalah nilai sejarahnya. Kotagede dulu punya tiga lapangan, yaitu Karang, Jambon, dan Winong. Lapangan Karang sendiri pernah menjadi markas tim-tim legendaris seperti Angkatan Muda, Barata, Sekar Mas, sampai Perseja Jambon. Jadi setiap kali bermain di sini, ada aura sepak bola tempo dulu yang ikut terasa.",
      "Lokasinya yang berada di tengah kawasan Kota Gede juga jadi nilai tambah. Selesai main, tim bisa langsung berburu kuliner legendaris dan jajanan khas Kotagede, atau mampir melihat sentra kerajinan perak. Main bola sambil kulineran, paket lengkap khas Jogja.",
      "Kesimpulan The 30s, Lapangan Karang Kotagede cocok banget buat fun football yang serius soal kualitas rumput, ditambah suasana historis dan kuliner di sekitarnya. Rating kami: 4.7 dari 5.",
    ],
  },
  {
    slug: "review-lapangan-baru-umy-jogja",
    title: "Review Lapangan Baru UMY Jogja: Rumput Standar FIFA, Wajib Coba!",
    category: "REVIEW LAPANGAN",
    date: "2026-06-08",
    author: "Tim Media The 30s",
    location: "Kampus Terpadu UMY, Kasihan, Bantul",
    rating: 4.8,
    cover: "/umy-lapangan.jpg",
    excerpt:
      "Lapangan sepak bola UMY yang baru direnovasi dengan biaya Rp2,2 miliar ini pakai rumput semi-sintetis berstandar FIFA. Begini pengalaman The 30s main di sini.",
    content: [
      "Universitas Muhammadiyah Yogyakarta (UMY) baru saja melakukan soft launching lapangan sepak bola yang direnovasi dengan anggaran sekitar Rp2,2 miliar. Begitu menginjak lapangan, kesan pertama langsung terasa: ini bukan lapangan kampus biasa.",
      "Highlight utamanya jelas di kualitas rumput. UMY mengganti permukaan lapangan dengan rumput semi-sintetis berstandar internasional FIFA. Pijakan terasa empuk tapi stabil, bola bergulir mulus, dan risiko cedera saat sliding jauh berkurang dibanding lapangan tanah keras yang biasa kita temui.",
      "Yang bikin kami salut, lapangan ini memakai konsep sub-surface drainage. Artinya, walaupun Jogja diguyur hujan sebelum kick-off, permukaan tetap kering dan tidak ada genangan yang mengganggu permainan. Buat tim yang sering kebagian slot sore-malam, ini nilai plus besar.",
      "Fasilitas pendukung di sekitar kampus juga lengkap: ada jogging track, lapangan futsal, basket, voli, tenis, badminton, sampai fitness center, semuanya di lingkungan kampus yang asri. Ke depan UMY berencana menambah tribun dan pusat kebugaran.",
      "Kesimpulan The 30s: lapangan UMY ini salah satu venue terbaik di Jogja untuk fun football yang serius soal kualitas permukaan. Cocok buat sparring penting atau sekadar main bareng dengan kondisi lapangan profesional. Rating kami: 4.8/5.",
    ],
  },
  {
    slug: "review-bermain-di-stadion-mandala-krida",
    title: "Sensasi Bermain di Stadion Mandala Krida: Rasa Stadion Sungguhan",
    category: "REVIEW LAPANGAN",
    date: "2026-06-04",
    author: "Tim Media The 30s",
    location: "Jl. Kenari, Kota Yogyakarta",
    rating: 4.5,
    cover: "/mandala-krida.jpg",
    excerpt:
      "Main di stadion berkapasitas 30 ribu penonton dengan rumput zoysia matrella dan lintasan lari standar internasional. Pengalaman yang bikin merinding.",
    content: [
      "Tidak banyak tim amatir yang berkesempatan menjajal stadion sekelas Mandala Krida. Begitu masuk ke dalam, atmosfernya langsung berbeda — tribun megah berkapasitas sekitar 30 ribu penonton hasil renovasi besar mengelilingi lapangan, bikin adrenalin naik meski cuma laga internal.",
      "Permukaan lapangan menggunakan rumput jenis zoysia matrella, yang dikenal sebagai salah satu rumput terbaik untuk sepak bola. Teksturnya rapat dan rata, bola mengalir cepat dan presisi. Buat tim yang suka main dari kaki ke kaki, lapangan ini benar-benar memanjakan.",
      "Selain venue utama, kompleks Mandala Krida punya fasilitas lengkap: lintasan lari berstandar internasional, GOR voli pasir, lapangan basket, arena panjat tebing, mushola, toilet, area parkir, dan kantin. Pemanasan dan urusan logistik tim jadi gampang.",
      "Catatannya, karena ini stadion milik pemerintah daerah dengan agenda padat, akses untuk umum perlu perizinan dan penjadwalan jauh-jauh hari. Tapi kalau dapat slot, pengalamannya sangat sepadan.",
      "Kesimpulan The 30s: bermain di Mandala Krida memberi sensasi 'rasa stadion sungguhan' yang sulit ditandingi venue lain di Jogja. Rating kami: 4.5/5.",
    ],
  },
  {
    slug: "review-bermain-di-stadion-sultan-agung-bantul",
    title: "Review Stadion Sultan Agung Bantul: Lapangan Standar FIFA 105x68",
    category: "REVIEW LAPANGAN",
    date: "2026-05-30",
    author: "Tim Media The 30s",
    location: "Pacar, Sewon, Bantul",
    rating: 4.6,
    cover: "/sultan-agung.jpg",
    excerpt:
      "Markas lama Persiba Bantul ini punya lapangan ukuran FIFA penuh 105x68 meter, lampu untuk laga malam, dan tribun beratap. Begini kesan kami main di sini.",
    content: [
      "Stadion Sultan Agung di Bantul dibangun pada 2004 dan punya sejarah panjang sebagai kandang Persiba Bantul. Dengan kapasitas sekitar 30.000 penonton, stadion ini terasa lapang dan gagah saat dipakai bermain.",
      "Lapangan utamanya berukuran standar FIFA penuh, yakni 105 x 68 meter. Buat tim yang terbiasa main di lapangan mini, ukuran sebesar ini langsung terasa di kaki — butuh stamina ekstra, tapi sangat ideal untuk melatih pergerakan tanpa bola dan transisi.",
      "Fasilitasnya tergolong lengkap untuk ukuran stadion daerah: ada lapangan latihan terpisah, tribun penonton beratap yang nyaman, ruang VIP, area parkir mobil luas, dan sistem pencahayaan yang memungkinkan laga malam hari. Kompleksnya juga menyediakan fasilitas atletik, tenis, basket, hingga badminton.",
      "Soal keamanan dan aksesibilitas, stadion ini punya pemeriksaan di pintu masuk, CCTV di berbagai sudut, serta ramah difabel dengan jalur kursi roda dan toilet khusus. Sebagai catatan, status stadion sempat jadi opsi kandang sejumlah klub profesional, jadi ketersediaan jadwal perlu dicek dulu.",
      "Kesimpulan The 30s: Sultan Agung cocok banget kalau kamu ingin merasakan main di lapangan ukuran penuh dengan suasana stadion profesional, terutama untuk laga malam. Rating kami: 4.6/5.",
    ],
  },
];
